import React from 'react';
import {
  RadioGroup,
  Radio,
  makeStyles,
  tokens,
  Label,
  shorthands,
  Divider
} from '@fluentui/react-components';
import { SaveOptions, SaveOptionsResponse } from '../../types/email.types';

interface SaveOptionsPanelProps {
  options: SaveOptionsResponse;
  selectedOptions: SaveOptions;
  onOptionsChange: (options: SaveOptions) => void;
  disabled?: boolean;
}

const useStyles = makeStyles({
  section: {
    marginBottom: tokens.spacingVerticalL,
  },
  label: {
    marginBottom: tokens.spacingVerticalS,
    fontWeight: tokens.fontWeightSemibold,
  },
  radioOption: {
    ...shorthands.padding(tokens.spacingVerticalS, "0"),
  },
  description: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    marginLeft: tokens.spacingHorizontalXXL,
  },
  divider: {
    ...shorthands.margin(tokens.spacingVerticalL, "0"),
  }
});

export const SaveOptionsPanel: React.FC<SaveOptionsPanelProps> = ({
  options,
  selectedOptions,
  onOptionsChange,
  disabled
}) => {
  const styles = useStyles();

  const handleFormatChange = (_: any, data: any) => {
    onOptionsChange({ ...selectedOptions, format: data.value });
  };

  const handleStorageChange = (_: any, data: any) => {
    onOptionsChange({ ...selectedOptions, storageLocation: data.value });
  };

  return (
    <>
      <div className={styles.section}>
        <Label className={styles.label}>Save Format</Label>
        <RadioGroup
          value={selectedOptions.format}
          onChange={handleFormatChange}
          disabled={disabled}
        >
          {options.formats.map(format => (
            <div key={format.value} className={styles.radioOption}>
              <Radio
                value={format.value}
                label={format.displayName}
              />
              <div className={styles.description}>{format.description}</div>
            </div>
          ))}
        </RadioGroup>
      </div>

      <Divider className={styles.divider} />

      <div className={styles.section}>
        <Label className={styles.label}>Storage Location</Label>
        <RadioGroup
          value={selectedOptions.storageLocation}
          onChange={handleStorageChange}
          disabled={disabled}
        >
          {options.storageLocations.map(location => (
            <div key={location.value} className={styles.radioOption}>
              <Radio
                value={location.value}
                label={location.displayName}
              />
              <div className={styles.description}>{location.description}</div>
            </div>
          ))}
        </RadioGroup>
      </div>
    </>
  );
};

export default SaveOptionsPanel;
